import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "../css/RecipeDetailModal.css";

export default function RecipeDetailModal({ item, onClose }) {
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
        if (!item) {
            return undefined;
        }

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        const handleKeydown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeydown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', handleKeydown);
        };
    }, [item, onClose]);

    useEffect(() => {
        setIframeLoaded(false);
    }, [item]);

    if (!item?.detailUrl) {
        return null;
    }

    return createPortal(
        <div className="recipe-detail-overlay" onClick={onClose}>
            <div className="recipe-detail-modal" onClick={(event) => event.stopPropagation()}>
                <div className="recipe-detail-header">
                    <div className="recipe-detail-title-box">
                        <div className="recipe-detail-tag">菜谱详情</div>
                        <div className="recipe-detail-title">{item.name}</div>
                        {item.subtitle ? <div className="recipe-detail-subtitle">{item.subtitle}</div> : null}
                    </div>
                    <button className="recipe-detail-close" onClick={onClose} aria-label="关闭详情">
                        ×
                    </button>
                </div>

                <div className="recipe-detail-actions">
                    <a
                        className="recipe-detail-link"
                        href={item.detailUrl}
                        target="_blank"
                        rel="noreferrer"
                    >
                        新标签打开
                    </a>
                    <button className="recipe-detail-back" onClick={onClose}>
                        关闭并返回
                    </button>
                </div>

                <div className="recipe-detail-frame-box">
                    {!iframeLoaded ? (
                        <div className="recipe-detail-fallback">
                            <div className="recipe-detail-fallback-title">正在加载菜谱页面</div>
                            <div className="recipe-detail-fallback-copy">
                                如果页面长时间空白，可能是目标网站禁止 iframe 嵌入，可以直接点上方“新标签打开”。
                            </div>
                        </div>
                    ) : null}
                    <iframe
                        title={`${item.name} 做法详情`}
                        className="recipe-detail-frame"
                        src={item.detailUrl}
                        onLoad={() => setIframeLoaded(true)}
                    />
                </div>
            </div>
        </div>,
        document.body,
    );
}
